import { render, staticRenderFns } from "./PostalCodeZone.vue?vue&type=template&id=aa35aaa0&scoped=true"
import script from "./PostalCodeZone.vue?vue&type=script&lang=js"
export * from "./PostalCodeZone.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeZone.vue?vue&type=style&index=0&id=aa35aaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35aaa0",
  null
  
)

export default component.exports